"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _projectType = require("@/api/project/projectType");
var _project = require("@/api/project/project");
var _public = require("@/api/public/public");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default
  },
  data: function data() {
    return {
      loading: false,
      // 作品清单
      workList: [{
        name: "",
        endTime: "",
        startTime: ""
      }],
      // 文件列表
      fileList: [],
      // 添加材料的列表
      mateList: [{
        id: "",
        materialName: "",
        endTime: "",
        startTime: ""
      }],
      list: [],
      yearList: [{
        name: "2021",
        value: "2021"
      }, {
        name: "2022",
        value: "2022"
      }, {
        name: "2023",
        value: "2023"
      }, {
        name: "2024",
        value: "2024"
      }, {
        name: "2025",
        value: "2025"
      }, {
        name: "2026",
        value: "2026"
      }, {
        name: "2027",
        value: "2027"
      }, {
        name: "2028",
        value: "2028"
      }, {
        name: "2029",
        value: "2029"
      }, {
        name: "2030",
        value: "2030"
      }],
      typeList: [{
        keyData: "中职",
        valueData: "1"
      }, {
        keyData: "高职",
        valueData: "2"
      }, {
        keyData: "本科",
        valueData: "3"
      }],
      form: {
        matchName: "",
        //项目名称
        matchType: "",
        //项目类型
        matchYear: "",
        //项目年份
        // checkList: ["教育局"], //项目
        isNeedForm: 0,
        //是否需要报名表
        isNeedCheckForm: 1,
        //
        materialListParamList: "",
        //材料设置
        matchWorkFormRuleList: "",
        //作品清单列表
        endTime: "",
        //结束时间
        schoolType: "",
        //参与比赛院校类型
        startTime: "",
        // 开始时间
        sort: 0,
        //排序
        id: "",
        //序号
        formProcessId: "",
        //报名表所属流程
        agreement: "",
        //专家承诺书
        remake: ""
      },
      rules: {
        matchName: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        matchType: [{
          required: true,
          message: "请选择项目类型。",
          trigger: "change"
        }],
        matchYear: [{
          required: true,
          message: "请选择项目年份。",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    //专家承诺书
    getUploadFileData: function getUploadFileData(data) {
      console.log(data, 'chengnuos');
      if (data.code === 1) {
        this.form.agreement = data.ossOriUrl;
        this.$message.success("上传成功。");
      }
    },
    // 获取项目级别下拉列表
    getTypeList: function getTypeList() {
      (0, _public.selectList)({
        businessTypeId: "3"
      }).then(function (res) {
        // this.typeList = res.data;
      });
    },
    // 添加作品清单
    addWorks: function addWorks() {
      this.workList.push({
        name: "",
        endTime: "",
        startTime: ""
      });
    },
    // 删除作品清单
    removeWorks: function removeWorks(index) {
      this.workList.splice(index, 1);
    },
    // 添加材料
    addMajor: function addMajor() {
      this.mateList.push({
        materialName: "",
        id: "",
        startTime: "",
        endTime: ""
      });
    },
    // 删除材料
    removeMajor: function removeMajor(index) {
      this.mateList.splice(index, 1);
    },
    // 提交
    submit: function submit(v) {
      var _this = this;
      console.log(' this.form', this.form);
      this.form.schoolType = this.form.schoolType.toString();
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this.form.materialListParamList = _this.mateList;
          _this.form.matchWorkFormRuleList = _this.workList;
          // this.mateList.forEach(item=>{

          // })
          (0, _project.projectAdd)(_this.form).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("操作成功。");
              _this.$router.push("/object/object");
            }
          });
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/object/object");
    }
  },
  created: function created() {
    var _this2 = this;
    this.proFlag = JSON.parse(sessionStorage.getItem("book")) || "";
    // 获取项目级别类别
    this.getTypeList();
    // 项目类型列表
    (0, _projectType.projectTypeListAll)().then(function (res) {
      var data = res.data;
      _this2.list = data.list;
    });
  }
};